'use strict';

import 'bootstrap';

$(function() {
    $(window).on('scroll', function() {
        var that = $(this);
        if (that.scrollTop() >= 52) {
            $('body').addClass('fixed');
        }
        else {
            $('body').removeClass('fixed');
        }
    });
    $('.dropdown').each(function() {
        var that = $(this);
        that.find('.dropdown-toggle .label').text(that.find('.active').text());
        that.find('.dropdown-menu a').on('click', function() {
            that.find('.active').removeClass('active');
            that.find('.dropdown-toggle .label').text($(this).text());
            $(this).addClass('active');
        });
        that.find('.dropdown-box').on('scroll', getScrollValue);
        function getScrollValue() {
            var now = this.scrollTop >> 0;
            var item = that.find('li');
            if ((item.outerHeight() * item.length - 255 - 20) < Math.abs(now) ) {
                item.parents('.dropdown-menu').removeClass('backdrop');
            }
            else {
                item.parents('.dropdown-menu').addClass('backdrop');
            }
        }
        
    });
    $('.btn-sort').on('click',function(e){
        e.preventDefault();
        $('html, body').scrollTop(0);
    });
});